import React from 'react';
import { AGREEMENT_STATUS } from '../../constants';
import { Badge } from 'framework/ui/mui-builder';
import { BadgeLayoutProps } from 'framework/ui/uiContract';

interface AgreementStatusChipProps {
  status: keyof typeof AGREEMENT_STATUS | null;
}

const STATUS_CONFIG: Record<string, { label: string; color: BadgeLayoutProps['color'] }> = {
  [AGREEMENT_STATUS.DRAFT]: { label: 'Draft', color: 'default' },
  [AGREEMENT_STATUS.ACTIVE]: { label: 'Active', color: 'success' },
  [AGREEMENT_STATUS.TERMINATED]: { label: 'Terminated', color: 'error' },
  [AGREEMENT_STATUS.EXPIRED]: { label: 'Expired', color: 'warning' },
};

const AgreementStatusChip: React.FC<AgreementStatusChipProps> = ({ status }) => {
  const config = STATUS_CONFIG[status as string];

  if (!config) return null;

  return (
    <Badge
      color={config.color}
      sx={{
        fontSize: '10px',
      }}
    >
      {config.label}
    </Badge>
  );
};

export default AgreementStatusChip;
